import { Colors } from '@/common/colors/colors';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import Form from '@/common/components/Form';
import Input from '@/common/components/Input';
import PopUp from '@/common/components/PopUp';
import SelectInput from '@/common/components/SelectInput';
import ToggleSwitch from '@/common/components/ToggleSwitch';
import useAddAccountForm from '../hooks/useAddAccountForm';
import { SPEND_SOURCES } from '@/common/constants/spend_sources';

const AddAccountForm = ({ setShow, account, metaAccounts }) => {
	const hook = useAddAccountForm({ setShow, account, metaAccounts });

	return (
		<PopUp setShow={setShow}>
			<Form
				title={`${
					Object.keys(account).length > 0 ? 'Edit' : 'Create'
				} Add Account`}
				onSubmit={(e) => hook.handleSubmit(e)}
			>
				<SelectInput
					color={Colors.darkBlue}
					name='Meta Account'
					options={hook.metaAccountsOptions}
					width={150}
					setSelected={hook.setMetaAccount}
					selected={hook.metaAccount}
					required
				/>
				<SelectInput
					color={Colors.darkBlue}
					name='Source'
					options={SPEND_SOURCES}
					width={150}
					setSelected={hook.setSource}
					selected={hook.source}
					required
				/>
				<SelectInput
					color={Colors.darkBlue}
					name='Market'
					options={hook.marketsOptions}
					width={150}
					setSelected={hook.setMarketId}
					selected={hook.marketId}
					required
				/>
				<SelectInput
					color={Colors.darkBlue}
					name='Product'
					options={hook.productsOptions}
					width={150}
					setSelected={hook.setProductId}
					selected={hook.productId}
					required
				/>
				<Input
					inputRef={hook.nameRef}
					value={account?.name}
					name='Name'
					color={Colors.darkBlue}
					width={150}
					requiredSign={true}
					placeholder='Type name...'
				/>
				<Input
					inputRef={hook.addAccountIdRef}
					value={account?.add_account_id}
					name='Add account ID'
					width={150}
					color={Colors.darkBlue}
					placeholder='Insert add account ID...'
				/>
				<ToggleSwitch
					toggleRef={hook.isActiveRef}
					checked={account?.is_active}
					text='Is Active:'
					width={148}
					gap='45px'
				/>
				<SubmitButton
					text='Save'
					style={{ marginTop: '10px', marginLeft: 'auto' }}
				/>
			</Form>
		</PopUp>
	);
};

export default AddAccountForm;
